import Modal from "./presentation";

export default Modal;